import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded, FuseAnimateGroup } from '@fuse';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, TableRow, TableHead, TableCell, TableBody, Table, LinearProgress, Tab } from '@material-ui/core';
import ReactTable from "react-table";
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    right: {
        'text-align': 'right'
    },
    testClass: {
        position: 'fixed',
        padding: '4px 56px 4px 24px',
        textAlign: 'left',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        height: '56px'
    }
});

class GradebookSummary extends Component {
    state = {
        calendar_course_id: 0,
        current_tab: 0,
        show_required_only: true,
        show_ungradable: true,
    }

    constructor(props) {
        super(props);


        this.state = {
            ...this.state,
            calendar_course_id: this.props.calendar_course_id,
        }
    }

    componentDidMount = () => {
        this.props.getCourseGradebook(this.state.calendar_course_id);
    }

    handleButtonClick = (button_name) => {
        this.setState({
            [button_name]: !this.state[button_name]
        })
    }

    handleStudentClick = (student_info) => {
        this.props.history.push(`/gradebook/student/event_list/${this.state.calendar_course_id}/${student_info.student_id}`);
    }

    // filterGradebook = (event_list) => {
    //     const { show_required_only, show_ungradable } = this.state;

    //     return event_list.filter((event_info) => {
    //         let show_event = false;

    //         if (show_ungradable && !event_info.EventIsGradable) {
    //             show_event = show_event || true;
    //         }

    //         if (show_required_only && event_info.EventIsRequired) {
    //             show_event = true;
    //         }

    //         return show_event;
    //     })
    // }

    getCourseTable = () => {
        const { course_gradebook, classes } = this.props;
        // const event_list = this.filterGradebook(course_gradebook.event_list);
        // const eventColumn = (event) => {
        //     if (event.EventIsGradable === 0) {

        //     }
        // }

        return (
            <React.Fragment>
                <div style={{ overflowX: 'scroll' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Student</TableCell>
                                <TableCell>Total Grade</TableCell>
                                {course_gradebook.event_list.map(event_info => (
                                    <TableCell key={event_info.company_calendar_event_id}>{event_info.EventName}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {course_gradebook.student_list.map((student_info) => {
                                return (
                                    <TableRow key={student_info.student_id}>
                                        <TableCell>{student_info.StudentName}</TableCell>
                                        <TableCell>{student_info.totalGrade}</TableCell>
                                        {student_info.events.map((event) => {
                                            return (
                                                <TableCell key={event.company_calendar_event_id}>
                                                    {event.EventIsGradable === 0 ? event.EventStatus : Number(event.EventScore).toFixed(1)}
                                                </TableCell>
                                            )
                                        })}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </div>

            </React.Fragment>
        )
    }

    getPageContent = (current_tab) => {
        switch (current_tab) {
            case (0): // Event list
                {
                    return this.getCourseTable();
                }

            case (1): // Statistics
                {
                    return (
                        <div>statistics</div>
                    )
                }

            default:
                {
                    return <React.Fragment>Error: No tab found.</React.Fragment>
                }
        }
    }

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            current_tab: value
        });
    }

    render() {
        const { classes } = this.props;
        const { current_tab } = this.state;
        const page_content = this.getPageContent(current_tab);

        return page_content;
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourseGradebook: Actions.getCourseGradebook,
        getCourseEventList: Actions.getCourseEventList,
        getCourseStudentList: Actions.getCourseStudentList,
        setTableSort: TableActions.setTableSort,
        setTableFilter: TableActions.setTableFilter,
    }, dispatch);
}

function mapStateToProps({ gradebookApp, tableSort, auth }) {
    return {
        courseEventList: gradebookApp.gradebook.courseEventList,
        courseStudentList: gradebookApp.gradebook.courseStudentList,
        course_name: gradebookApp.gradebook.course_name,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        is_loaded: tableSort.is_loaded,
        course_gradebook: gradebookApp.gradebook.course_gradebook,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(GradebookSummary)));


// WEBPACK FOOTER //
// src/main/content/gradebook/GradebookSummary.js